import React, { useEffect, useState } from "react";
import {
  Box,
  CircularProgress,
  Grid,
  IconButton,
  Pagination,
  Tooltip,
  Typography,
} from "@mui/material";
import Layout from "app/layout/Layout";
import colors from "app/styles/colors";
import BreadCrumbs from "app/components/Breadcrumbs/Breadcrumbs";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Delete } from "@mui/icons-material";
import { SuccessToaster } from "app/components/Toaster/Toaster";
import TransitService from "app/apis/Goeasy/Transit/TransitService";

function TransitBooking() {
  const [dataList, setDataList] = useState([]);
  const [currentLinks, setCurrentLinks] = useState([]);
  const [listLoader, setListLoader] = useState(true);

  const getData = async (pageNo) => {
    try {
      setListLoader(true);
      let res = await TransitService.getTransitService();
      setCurrentLinks(res?.data?.meta?.links?.slice(1, -1));
      setDataList(res?.data?.data);
    } catch (error) {
      console.log("🚀 ~ getData ~ error:", error);
    } finally {
      setListLoader(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      let res = await TransitService.deleteTransitService({ id });
      SuccessToaster(res?.message);
      getData();
    } catch (error) {
      console.log("🚀 ~ updateStatus ~ error:", error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <Layout>
      <Box
        sx={{ backgroundColor: colors.lightGray, p: 3, borderRadius: "12px" }}
      >
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{ bgcolor: colors.white, p: 2, borderRadius: "12px" }}
        >
          <Grid item xs={6}>
            <Typography variant="body1" fontWeight="bold" color="initial">
              Transit Shuttles Bookings
            </Typography>
          </Grid>
          <Grid
            item
            xs={6}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <BreadCrumbs currentPage="Tansit Shuttles Bookings" />
          </Grid>
        </Grid>

        <Box sx={{ mt: 2, bgcolor: colors.white, p: 2, borderRadius: 4 }}>
          {listLoader ? (
            <Box sx={{ textAlign: "center" }}>
              <CircularProgress color="success" />
            </Box>
          ) : (
            <>
              <TableContainer component={Paper} sx={{ my: 2 }}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow sx={{ bgcolor: colors.primary }}>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        Purpose
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        From
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        To
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        Date
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        Departure Time
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        No of Passengers
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        Contact
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        Action
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {dataList?.map((row, index) => (
                      <TableRow
                        key={row?.id}
                        sx={{
                          bgcolor: index % 2 ? colors.lightGray : "white",
                        }}
                      >
                        <TableCell>{row?.transit_type ?? "-"}</TableCell>
                        <TableCell>{row?.from_location ?? "-"}</TableCell>
                        <TableCell>{row?.to_location ?? "-"}</TableCell>
                        <TableCell>{row?.date ?? "-"}</TableCell>
                        <TableCell>{row?.time ?? "-"}</TableCell>
                        <TableCell>{row?.no_of_passengers ?? "-"}</TableCell>
                        <TableCell>{row?.contact_no ?? "-"}</TableCell>

                        {/* Action */}
                        <TableCell>
                          <Box sx={{ display: "flex" }}>
                            <IconButton
                              onClick={() => {
                                handleDelete(row.id);
                              }}
                              size="small"
                            >
                              <Tooltip title="Delete Booking">
                                <Delete color="error" />
                              </Tooltip>
                            </IconButton>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          )}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Pagination
              variant="outlined"
              color="success"
              count={currentLinks?.length}
              onChange={(e, value) => getData(value)}
            />
          </Box>
        </Box>
      </Box>
    </Layout>
  );
}

export default TransitBooking;
